export default {
  submitText: '保存',
  emptyBtn: false,
  column: [
    {
      label: '上级节点',
      prop: 'parentParkName',
      disabled: true,
      span: 12,
    },
    {
      label: '上级属性',
      prop: 'parentTypeName',
      disabled: true,
      span: 12,
    },
    {
      label: '节点名称',
      prop: 'spaceName',
      rules: [
        {
          required: true,
          message: '请输入节点名称',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '节点属性',
      prop: 'type',
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择节点属性',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '车位数',
      prop: 'parkLotNumber',
      type: 'number',
      rules: [
        {
          required: true,
          message: '请输入车位数',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '临停车位',
      prop: 'tempParkFlag',
      rules: [
        {
          required: true,
          message: '请输入临停车位',
          trigger: 'blur',
        },
      ],
      formslot: true,
      span: 12,
    },
    {
      label: '状态',
      prop: 'carParkStatus',
      formslot: true,
      rules: [
        {
          required: true,
          message: '请输入状态',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '本地编号',
      prop: 'blockLocalNo',
      hide: true,
      span: 12,
      rules: [
        {
          max: 100,
          message: '请输入状态',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '单独计费',
      prop: 'carParkAreaType',
      formslot: true,
      display: true,
      span: 12,
      rules: [
        {
          required: true,
          message: '请选择计费方式',
          trigger: 'change',
        },
      ],
    },
  ],
};
